import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import ResourcesPage from './pages/ResourcesPage';
import CreateResourcePage from './pages/CreateResourcePage';
import ModifyResourcePage from './pages/ModifyResourcePage';
import ManualRequestPage from './pages/ManualRequestPage';
import UsagesPage from './pages/UsagesPage';
import LicenseSummaryPage from './pages/LicenseSummaryPage';
import PastUsagesPage from './pages/PastUsagesPage';
import ProductivityGapsPage from './pages/ProductivityGapsPage';
import QuotasPage from './pages/QuotasPage';
import CreateQuotaPage from './pages/CreateQuotaPage';
import ModifyQuotaPage from './pages/ModifyQuotaPage';
import QuotaMatchesPage from './pages/QuotaMatchesPage';
import LicensesPage from './pages/LicensesPage';
import SettingsPage from './pages/SettingsPage';
import ServerActivityPage from './pages/ServerActivityPage';

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Navigate to="/resources" replace />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/resources/new" element={<CreateResourcePage />} />
        <Route path="/resources/:name/modify" element={<ModifyResourcePage />} />
        <Route
          path="/resources/:name/manual-request"
          element={<ManualRequestPage />}
        />
        <Route path="/resources/:name/usages" element={<UsagesPage />} />
        <Route
          path="/resources/:name/license-summary"
          element={<LicenseSummaryPage />}
        />
        <Route
          path="/resources/:name/past-usages"
          element={<PastUsagesPage />}
        />
        <Route
          path="/resources/:name/productivity-gaps"
          element={<ProductivityGapsPage />}
        />
        <Route path="/quotas" element={<QuotasPage />} />
        <Route path="/quotas/new" element={<CreateQuotaPage />} />
        <Route path="/quotas/:name/modify" element={<ModifyQuotaPage />} />
        <Route path="/quotas/:name/matches" element={<QuotaMatchesPage />} />
        <Route path="/licenses" element={<LicensesPage />} />
        <Route path="/server-activity" element={<ServerActivityPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route
          path="*"
          element={
            <div className="py-20 text-center">
              <h1 className="text-xl font-semibold">Not found</h1>
              <p className="mt-2 text-sm text-muted-foreground">
                The page you're looking for does not exist in v2.
              </p>
            </div>
          }
        />
      </Routes>
    </AppShell>
  );
}
